import { service } from '@ember/service';
import Component from '@glimmer/component';

import { trackedFunction } from 'reactiveweb/function';

import Form from 'umg-ember-backend/components/ui/form';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

import ContentItem from './for/content-item';
import ContentItemHeroHeader from './for/content-item-hero-header';
import ContentItemHtml from './for/content-item-html';
import ContentItemLink from './for/content-item-link';
import ContentItemMlpSlider from './for/content-item-mlp-slider';
import ContentItemProduct from './for/content-item-product';
import ContentItemSpacer from './for/content-item-spacer';
import Mlp from './for/mlp';
import MlpPage from './for/mlp-page';

const FORM_COMPONENTS = {
  'content-item': ContentItem,
  'content-item-hero-header': ContentItemHeroHeader,
  'content-item-html': ContentItemHtml,
  'content-item-link': ContentItemLink,
  'content-item-mlp-slider': ContentItemMlpSlider,
  'content-item-product': ContentItemProduct,
  'content-item-spacer': ContentItemSpacer,
  'mlp': Mlp,
  'mlp-page': MlpPage,
};

export default class PageBuilderOptionsForms extends Component {
  // Services
  @service pageBuilderFrontendApi;

  // Getter and setter
  get ComponentName() {
    const { type } = this.args.model;
    const recordType = getRecordType(this.args.model);
    const componentName = `${recordType}-${type}`;

    if (FORM_COMPONENTS[componentName]) {
      return FORM_COMPONENTS[componentName];
    }

    return FORM_COMPONENTS[recordType];
  }

  get elementConfig() {
    const { type } = this.args.model;
    const recordType = getRecordType(this.args.model);

    return this.themeConfig?.cms?.[type ?? recordType];
  }

  get themeConfig() {
    return this.loadThemeConfig.value;
  }

  // Functions
  loadThemeConfig = trackedFunction(this, async () => {
    return await this.pageBuilderFrontendApi.loadThemeConfig(
      this.pageBuilderFrontendApi.host,
      this.args.mlp,
    );
  });

  // Template
  <template>
    <Form
      @disableLocking={{true}}
      @model={{@model}}
      @showErrors={{@showErrors}}
      as |form|
    >
      <this.ComponentName
        @form={{form}}
        @model={{form.model}}
        @elementConfig={{this.elementConfig}}
        @loadLegalContext={{@loadLegalContext}}
        @mlp={{@mlp}}
      />
    </Form>
  </template>
}
